/**
 * Fields are identified by name, autocomplete, and data-credential — not by the
 * live input type. Showing the password changes that control to type="text",
 * and treating every text input as the email writes the password into the username.
 */
export function readAutofilledCredentials(
  inputs: Array<Pick<HTMLInputElement, 'type' | 'value' | 'getAttribute'>>,
): { email: string; password: string } {
  let email = '';
  let password = '';

  inputs.forEach((input) => {
    const name = input.getAttribute('name');
    const autocomplete = input.getAttribute('autocomplete');
    const credential = input.getAttribute('data-credential');

    if (
      credential === 'password' ||
      name === 'password' ||
      autocomplete === 'current-password' ||
      input.type === 'password'
    ) {
      password = input.value || password;
      return;
    }

    if (
      credential === 'username' ||
      name === 'username' ||
      autocomplete === 'username' ||
      input.type === 'email'
    ) {
      email = input.value || email;
    }
  });

  return { email, password };
}
